import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import { useState } from "react";

import { fieldSx, sectionInnerSx } from "./sectionStyles";

export interface BroadcastCancelScheduleSectionProps {
  onCancelSchedule: () => void;
  isCancelling?: boolean;
}

/** "Type CANCEL" destructive gate for cancelling a scheduled broadcast. */
export function BroadcastCancelScheduleSection({
  onCancelSchedule,
  isCancelling,
}: BroadcastCancelScheduleSectionProps) {
  const [cancelText, setCancelText] = useState("");

  return (
    <Stack
      gap={2}
      sx={{
        backgroundColor: (theme) =>
          theme.palette.background["paper-elevation-0"],
        borderRadius: (theme) => `${theme.shape.borderRadiusMd}px`,
        p: 6,
      }}
    >
      <Typography variant="subtitle1">Cancel broadcast</Typography>
      <Stack gap={2} sx={sectionInnerSx}>
        <Typography variant="body2" color="text.secondary">
          Type &apos;CANCEL&apos; to cancel this scheduled broadcast
        </Typography>
        <TextField
          value={cancelText}
          onChange={(e) => setCancelText(e.target.value)}
          fullWidth
          placeholder="CANCEL"
          inputProps={{ "aria-label": "Cancel broadcast schedule" }}
          sx={fieldSx}
        />
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
          <Button
            variant="contained"
            color="error"
            disabled={cancelText !== "CANCEL" || isCancelling}
            onClick={onCancelSchedule}
          >
            Cancel Broadcast
          </Button>
        </Box>
      </Stack>
    </Stack>
  );
}
